import { Quill } from "react-quill-new";
import StyledToolTip from "../StyledTooltip";

// Custom Undo button icon component for Quill editor. You can import it directly
// from 'quill/assets/icons/undo.svg' but I found that a number of loaders do not
// handle them correctly
const CustomUndo = () => (
  <svg viewBox="0 0 18 18">
    <polygon className="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10" />
    <path
      className="ql-stroke"
      d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"
    />
  </svg>
);

// Redo button icon component for Quill editor
const CustomRedo = () => (
  <svg viewBox="0 0 18 18">
    <polygon className="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10" />
    <path
      className="ql-stroke"
      d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"
    />
  </svg>
);

// Undo and redo functions for Custom Toolbar
// Removed as handlers are now passed as props



// Add sizes to whitelist and register them
const Size = Quill.import("formats/size");
(Size as any).whitelist = ["extra-small", "small", "medium", "large"];
Quill.register(Size as any, true);

// Add fonts to whitelist and register them
const Font = Quill.import("formats/font");
(Font as any).whitelist = [
  "arial",
  "comic-sans",
  "courier-new",
  "georgia",
  "helvetica",
  "lucida",
];
Quill.register(Font as any, true);

// History module is built-in to Quill, no need to register it explicitly

// Modules object for setting up the Quill editor
export const modules = {
  toolbar: {
    container: "#toolbar",
  },
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true,
  },
};

// Formats objects for setting up the Quill editor
export const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "align",
  "strike",
  "script",
  "blockquote",
  "background",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "color",
  "code-block",
];

// Quill Toolbar component
// export const QuillToolbar = () => (
//   <div id="toolbar">
//     {/* <select className="ql-font" defaultValue="arial">
//         <option value="arial">Arial</option>
//         <option value="comic-sans">Comic Sans</option>
//         <option value="courier-new">Courier New</option>
//         <option value="georgia">Georgia</option>
//         <option value="helvetica">Helvetica</option>
//         <option value="lucida">Lucida</option>
//         </select> */}
//     {/* <select className="ql-size" defaultValue="medium">
//         <option value="extra-small">Size 1</option>
//         <option value="small">Size 2</option>
//         <option value="medium">Size 3</option>
//         <option value="large">Size 4</option>
//         </select> */}
//     <span className="ql-formats">
//       <button className="ql-bold" />
//       <button className="ql-italic" />
//       <button className="ql-underline" />
//       <button className="ql-blockquote " />
//     </span>
//     {/* <span className="ql-formats">
//       <select className="ql-header ml-0" defaultValue="3">
//         <option value="1">Heading</option>
//         <option value="2">Subheading</option>
//         <option value="3">Normal</option>
//       </select>
//     </span> */}
//     <span className="ql-formats">
//       <button className="ql-list" value="ordered" />
//       <button className="ql-list" value="bullet" />
//       <button className="ql-indent" value="-1" />
//       <button className="ql-indent" value="+1" />
//     </span>
//     {/* <span className="ql-formats">
//       <button className="ql-script" value="super" />
//       <button className="ql-script" value="sub" />
//       <button className="ql-blockquote" />
//       <button className="ql-direction" />
//     </span> */}
//     {/* <span className="ql-formats"> */}
//     {/* <select className="ql-align" /> */}
//     {/* <select className="ql-color" /> */}
//     {/* <select className="ql-background" /> */}
//     {/* </span> */}
//     {/* <span className="ql-formats">
//       <button className="ql-link" />
//       <button className="ql-image" />
//     </span> */}
//     {/* <button className="ql-video" /> */}
//     <span className="ql-formats">
//       {/* <button className="ql-formula" /> */}
//       <button className="ql-code-block" />
//       <button className="ql-clean" />
//     </span>
//     <span className="ql-formats">
//       <button className="ql-undo">{/* <CustomUndo /> */}u</button>
//       <button className="ql-redo">r</button>
//       <button className="ql-code">HTML</button>
//     </span>
//   </div>
//   /* <>
// <div id="toolbar-container">
//   <span className="ql-formats">
//     <select className="ql-font"></select>
//     <select className="ql-size"></select>
//   </span>
//   <span className="ql-formats">
//     <button className="ql-bold"></button>
//     <button className="ql-italic"></button>
//     <button className="ql-underline"></button>
//     <button className="ql-strike"></button>
//   </span>
//   <span className="ql-formats">
//     <select className="ql-color"></select>
//     <select className="ql-background"></select>
//   </span>
//   <span className="ql-formats">
//     <button className="ql-script" value="sub"></button>
//     <button className="ql-script" value="super"></button>
//   </span>
//   <span className="ql-formats">
//     <button className="ql-header" value="1"></button>
//     <button className="ql-header" value="2"></button>
//     <button className="ql-blockquote"></button>
//     <button className="ql-code-block"></button>
//   </span>
//   <span className="ql-formats">
//     <button className="ql-list" value="ordered"></button>
//     <button className="ql-list" value="bullet"></button>
//     <button className="ql-indent" value="-1"></button>
//     <button className="ql-indent" value="+1"></button>
//   </span>
//   <span className="ql-formats">
//     <button className="ql-direction" value="rtl"></button>
//     <select className="ql-align"></select>
//   </span>
//   <span className="ql-formats">
//     <button className="ql-link"></button>
//     <button className="ql-image"></button>
//     <button className="ql-video"></button>
//     <button className="ql-formula"></button>
//   </span>
//   <span className="ql-formats">
//     <button className="ql-clean"></button>
//   </span>
// </div>
// <div id="editor">
// </div>
// </> */
// );

export const QuillToolbar = ({ onUndo, onRedo }: { onUndo?: () => void, onRedo?: () => void }) => (
  <div id="toolbar">
    
    <div className="ql-formats d-flex overflow-auto me-0 toolbar-flex">
       <StyledToolTip title="Bold" childrenClass={'ms-0'}>
            <button className="ql-bold" />
          </StyledToolTip>
          <StyledToolTip title="Italic" childrenClass={'ms-0'}>
            <button className="ql-italic" />
          </StyledToolTip>
          <StyledToolTip title="Underline" childrenClass={'ms-0'}>
            <button className="ql-underline" />
          </StyledToolTip>
          <StyledToolTip title="Paragraph" childrenClass={'ms-0'}>
            <button className="ql-direction" value="rtl" />
          </StyledToolTip>
      <StyledToolTip title="Numbered list" childrenClass={"ms-0"}>
        <button className="ql-list" value="ordered" />
      </StyledToolTip>
      <StyledToolTip title="Bullet points" childrenClass={"ms-0"}>
        <button className="ql-list" value="bullet" />
      </StyledToolTip>
      <StyledToolTip title="Align left" childrenClass={"ms-0"}>
        <button className="ql-align" value="" />
      </StyledToolTip>
      <StyledToolTip title="Align Center" childrenClass={"ms-0"}>
        <button className="ql-align" value="center" />
      </StyledToolTip>
      <StyledToolTip title="Align right" childrenClass={"ms-0"}>
        <button className="ql-align" value="right" />
      </StyledToolTip>
      <StyledToolTip title="Justify" childrenClass={"ms-0"}>
        <button className="ql-align" value="justify" />
      </StyledToolTip>
      <StyledToolTip title="Insert/edit link" childrenClass={"ms-0"}>
        <button className="ql-link" />
      </StyledToolTip>

       <StyledToolTip title="Insert image" childrenClass={'ms-0'}>
            <button className="ql-image d-none" />
          </StyledToolTip>
          <StyledToolTip title="Insert video" childrenClass={'ms-0'}>
            <button className="ql-video d-none" />
          </StyledToolTip>
          <StyledToolTip title="Undo" childrenClass={'ms-0'}>
            <button type="button" onClick={(e) => { e.preventDefault(); onUndo?.(); }}>
              <CustomUndo />
            </button>
          </StyledToolTip>
          <StyledToolTip title="Redo" childrenClass={'ms-0'}>
            <button type="button" onClick={(e) => { e.preventDefault(); onRedo?.(); }}>
              <CustomRedo />
            </button>
          </StyledToolTip>
          <StyledToolTip title="Block" childrenClass={'ms-0'}>
            <button className="ql-code-block" />
          </StyledToolTip>
       
    </div>
  </div>
);

export default QuillToolbar;
